import { EditableText, Subheading } from '@criteria-labs/react'
import { type Resource } from '@criteria-labs/docs-kit'
import debounce from 'lodash.debounce'
import { useMemo } from 'react'
import { Section } from '../Section'
import { InspectorBody } from '../article'
import { UpdateTagDescription, UpdateTagName } from '../changes/tag'
import { InlineField, InlineFieldGroup, InlineLabel } from '../inline-fieldset'
import { useDispatchChange } from '../useDispatchChange'

export function ResourceOverview({ resource, resourceIndex }: { resource: Resource; resourceIndex: number }) {
  const dispatchChange = useDispatchChange()
  const debouncedDispatchChange = useMemo(() => debounce(dispatchChange), [dispatchChange])
  return (
    <InspectorBody>
      <Section className="mt-6">
        <Subheading className="flex min-h-10 items-center">General Information</Subheading>
        <InlineFieldGroup className="mt-3">
          <InlineField>
            <InlineLabel>Name</InlineLabel>
            <div data-slot="control" className="mt-0.5">
              <EditableText
                placeholder="Add a name…"
                className="text-sm"
                value={resource.tag.name}
                onChange={(value) => {
                  debouncedDispatchChange(new UpdateTagName(resourceIndex, value))
                }}
                onBlur={() => {
                  debouncedDispatchChange.flush()
                }}
              />
            </div>
          </InlineField>
          <InlineField>
            <InlineLabel>Description</InlineLabel>
            <div data-slot="control" className="mt-0.5">
              <EditableText
                multiline
                placeholder="Add a description…"
                className="text-sm"
                value={resource.description}
                onChange={(value) => {
                  debouncedDispatchChange(new UpdateTagDescription(resourceIndex, value))
                }}
                onBlur={() => {
                  debouncedDispatchChange.flush()
                }}
              />
            </div>
          </InlineField>
        </InlineFieldGroup>
      </Section>
    </InspectorBody>
  )
}
